import { Injectable } from '@angular/core';
import { LazyLoadedComponentType } from '../landing-pages/components/lazy-slice/lasy-slice-types';

@Injectable({
  providedIn: 'root',
})
export class LazySliceService {
  public async loadSliceComponent(type: string): Promise<LazyLoadedComponentType> {
    if (type === 'tariff_table') return this.loadTarrifTableComponent();
    if (type === 'table_embed') return this.loadTableComponent();
    if (type === 'hero_area') return this.loadHeroAreaComponent();
    if (type === 'phone_number_slice') return this.loadPhoneNumberComponent();
    if (type === 'products') return this.loadProductsComponent();
    if (type === 'benefits_list') return this.loadBenefitsListComponent();
    if (type === 'offer_boxes') return this.loadOfferBoxesComponent();
    if (type === 'product_detail_overview') return this.loadProductDetailOverviewComponent();
    if (type === 'centered_accordion') return this.loadCenteredAccordionComponent();
    if (type === 'custom_content') return this.loadCustomContentComponent();
    if (type === 'line_check') return this.loadLineCheckComponent();
    if (type === 'content_boxes') return this.loadContentBoxesComponent();
    if (type === 'image_text') return this.loadImageTextComponent();
    if (type === 'modals') return this.loadModalsComponent();
    if (type === 'sign_up_form') return this.loadSignupformComponent();
    if (type === 'contest_form_embed') return this.loadContestFormformComponent();
    if (type === 'card_list') return this.loadCardListComponent();
    throw 'Invalid slice type: ' + type;
  }

  private async loadTarrifTableComponent() {
    const { TariffTableComponent } = await import('../landing-pages/slices/tariff-table/tariff-table.component');
    return TariffTableComponent;
  }

  private async loadTableComponent() {
    const { TableComponent } = await import('../landing-pages/slices/table/table.component');
    return TableComponent;
  }

  private async loadLineCheckComponent() {
    const { LineCheckComponent } = await import('../landing-pages/slices/line-check/line-check.component');
    return LineCheckComponent;
  }

  private async loadSignupformComponent() {
    const { SignupFormComponent } = await import('../landing-pages/slices/signup-form/signup-form.component');
    return SignupFormComponent;
  }

  private async loadContestFormformComponent() {
    const { ContestFormComponent } = await import('../landing-pages/slices/contest-form/contest-form.component');
    return ContestFormComponent;
  }

  private async loadModalsComponent() {
    const { ModalsComponent } = await import('../landing-pages/slices/modals/modals.component');
    return ModalsComponent;
  }

  private async loadOfferBoxesComponent() {
    const { OfferBoxesComponent } = await import('../landing-pages/slices/offer-boxes/offer-boxes.component');
    return OfferBoxesComponent;
  }

  private async loadHeroAreaComponent() {
    const { HeroAreaComponent } = await import('../landing-pages/slices/hero-area/hero-area.component');
    return HeroAreaComponent;
  }

  private async loadProductsComponent() {
    const { ProductsComponent } = await import('../landing-pages/slices/products/products.component');
    return ProductsComponent;
  }

  private async loadCustomContentComponent() {
    const { CustomContentComponent } = await import('../landing-pages/slices/custom-content/custom-content.component');
    return CustomContentComponent;
  }

  private async loadPhoneNumberComponent() {
    const { PhoneNumberComponent } = await import('../landing-pages/slices/phone-number/phone-number.component');
    return PhoneNumberComponent;
  }

  private async loadBenefitsListComponent() {
    const { BenefitsListComponent } = await import('../landing-pages/slices/benefits-list/benefits-list.component');
    return BenefitsListComponent;
  }

  private async loadProductDetailOverviewComponent() {
    const { ProductDetailOverviewComponent } = await import(
      '../landing-pages/slices/product-detail-overview/product-detail-overview.component'
    );
    return ProductDetailOverviewComponent;
  }

  private async loadCardListComponent() {
    const { CardListComponent } = await import('../landing-pages/slices/card-list/card-list.component');
    return CardListComponent;
  }

  private async loadContentBoxesComponent() {
    const { ContentBoxesComponent } = await import('../landing-pages/slices/content-boxes/content-boxes.component');
    return ContentBoxesComponent;
  }

  private async loadImageTextComponent() {
    const { ImageTextComponent } = await import('../landing-pages/slices/image-text/image-text.component');
    return ImageTextComponent;
  }

  private async loadCenteredAccordionComponent() {
    const { CenteredAccordionComponent } = await import(
      '../landing-pages/slices/centered-accordion/centered-accordion.component'
    );
    return CenteredAccordionComponent;
  }
}
